define("settings/components/plan-recommendation/progress-bar", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    aria-label={{t "account.plan_recommendation.progress_label" current=@current total=this.total}}
    aria-valuemax={{this.total}}
    aria-valuemin="1"
    aria-valuenow={{@current}}
    class="cPR--progress"
    data-test-id="plan-recommendation-progress"
    role="progressbar"
    ...attributes
  >
    {{#each this.segments as |isComplete|}}
      <span
        class={{concat-classes "cPR--progress__segment" (if isComplete "is--complete")}}
        data-test-complete={{if isComplete "true" "false"}}
        data-test-id="plan-recommendation-progress-segment"
      ></span>
    {{/each}}
  </div>
  */
  {
    "id": "l/R1U+GE",
    "block": "[[[11,0],[16,\"aria-label\",[28,[37,0],[\"account.plan_recommendation.progress_label\"],[[\"current\",\"total\"],[[30,1],[30,0,[\"total\"]]]]]],[16,\"aria-valuemax\",[30,0,[\"total\"]]],[24,\"aria-valuemin\",\"1\"],[16,\"aria-valuenow\",[30,1]],[24,0,\"cPR--progress\"],[24,\"data-test-id\",\"plan-recommendation-progress\"],[24,\"role\",\"progressbar\"],[17,2],[12],[1,\"\\n\"],[42,[28,[37,2],[[28,[37,2],[[30,0,[\"segments\"]]],null]],null],null,[[[1,\"    \"],[10,1],[15,0,[28,[37,3],[\"cPR--progress__segment\",[52,[30,3],\"is--complete\"]],null]],[15,\"data-test-complete\",[52,[30,3],\"true\",\"false\"]],[14,\"data-test-id\",\"plan-recommendation-progress-segment\"],[12],[13],[1,\"\\n\"]],[3]],null],[13]],[\"@current\",\"&attrs\",\"isComplete\"],false,[\"t\",\"each\",\"-track-array\",\"concat-classes\",\"if\"]]",
    "moduleName": "settings/components/plan-recommendation/progress-bar.hbs",
    "isStrictMode": false
  });

  /** The recommendation slide is deliberately not counted — the design shows three segments. */
  const QUESTION_COUNT = 3;
  class ProgressBarComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _defineProperty(this, "total", QUESTION_COUNT);
    }
    get segments() {
      return Array.from({
        length: QUESTION_COUNT
      }, (_unused, index) => this.args.current >= index + 1);
    }
  }
  _exports.default = ProgressBarComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ProgressBarComponent);
});